export const PASS_CONDIVISO = 
{
	BREADCRUMBS: "pass/condiviso/breadcrumbs",
};

export const PASS_HEADER = 
{
	TITOLO: "pass/header/titolo",
	SOTTOTITOLO: "pass/header/sottotitolo",
	DESCRIZIONE: "pass/header/descrizione",
};

export const PASS_HOME = 
{
	SPID_ATTIVO: "pass/home/spid/attivo",
	CIE_ATTIVO: "pass/home/cie/attivo",
};

